module.exports = "<prg-select-device-button iconClass=\"icon lightbulb\" [device]=\"(light | async)\" [buttons]=\"(buttons | async)\" (selected)=\"buttonSelected($event)\"></prg-select-device-button>\n"


//////////////////
// WEBPACK FOOTER
// ./~/@c4/programming/src/app/quickstarts/quickstart-lights/select-button/select-button.component.html
// module id = 1576
// module chunks = 2